module.exports = "../../static/img/imali_logo_big.db41624.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imali_logo_big.png
// module id = 87
// module chunks = 1